import apiClient from ".";

interface SupportBody {
    name: string;
    email: string;
    org: string;
    agent: string;
    problemType: string;
    message: string
}

export const contactSupport = async (body: SupportBody) => {
	const response = await apiClient.post(`/support`, body);
	return response.data;
}